/* eslint-disable arrow-parens */

import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  SET_AL_STORE_AGILLINK_CATEGORIES_GQL,
  GET_AL_STORED_AGILLINK_CATEGORIES_GQL,
  SET_AL_STORE_MAPPED_CATEGORIES_GQL,
  SET_AL_STORE_UNMAPPED_CATEGORIES_GQL,
  SET_AL_POST_TRANSACTIONS_GQL,
  SET_AL_MARK_TRANSACTIONS_DOWNLOADED_GQL,
  SET_ALSYS_DISCONNECT_GQL,
  GET_AL_STORED_AGILLINK_CC_ACCOUNTS_GQL,
  GET_AL_SELECTED_CC_ACCOUNT_GQL,
  SET_AL_STORE_CREDITCARD_ACCOUNT_GQL,
  SET_UPDATE_MAPPED_CATEGORIES_GQL,
  GET_ALL_TAB_CC_ACC_VALUE_GQL,
  SET_AL_STORE_SYNC_TRANSACTION_TOGGLE_VALUE_GQL,
  // GET_NEW_USER_ENTRIES_GQL

} from '@/graphql/agillink.gql';


const AWS = require('aws-sdk');

export default {
  namespaced: true,

  state: {
    agilLinkCategoriesStored: null,
    agilLinkAccountingCategoriesStored: null,
    storedAgillinkCategories: null,
    syncedAgilLinkTransactions: null,
    ledgerEntries: null,
    markDownloaded: null,
    agilLinkSysDisConnected: null,
    agilLinkCcAccountList: null,
    selectedCreditCardAccount: null,
    updatedMappedCategories: null,
    allTabCcAccValueList: null,
    syncTransactionToggleValue: null,
  },

  mutations: {
    SET_AL_STORED_AGILLINK_CATEGORIES(state, payload) {
      state.agilLinkCategoriesStored = payload;
    },
    GET_AL_STORED_AGILLINK_CATEGORIES(state, payload) {
      state.storedAgillinkCategories = payload;
    },
    GET_AL_STORED_AGILLINK_CC_ACCOUNTS(state, payload) {
      state.agilLinkCcAccountList = payload;
    },
    SET_AL_STORED_AGILLINK_ACCOUNTING_CATEGORIES(state, payload) {
      state.agilLinkAccountingCategoriesStored = payload;
    },
    SET_SYNC_AL_TRAN(state, payload) {
      state.syncedAgilLinkTransactions = payload;
    },
    /* GET_LEDGER_ENTRIES(state, payload) {
      state.ledgerEntries = payload;
    } */
    SET_AL_TRAN_MARK_DONWLOADED(state, payload) {
      state.markDownloaded = payload;
    },
    SET_ALSYS_DISCONNECT(state, payload) {
      state.agilLinkSysDisConnected = payload;
    },
    GET_AL_SELECTED_CC_ACCOUNT(state, payload) {
      state.selectedCreditCardAccount = payload;
    },
    SET_AL_STORE_CREDITCARD_ACCOUNT(state, payload) {
      state.selectedCreditCardAccount = payload;
    },
    SET_UPDATE_MAPPED_CATEGORIES(state, payload) {
      state.updatedMappedCategories = payload;
    },
    GET_ALL_TAB_CC_ACC_VALUE(state, payload) {
      state.allTabCcAccValueList = payload;
    },
    SET_AL_STORE_SYNC_TRANSACTION_TOGGLE_VALUE(state, payload) {
      state.syncTransactionToggleValue = payload;
    },
  },

  actions: {
    async storeAgilLinkCategories({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      // code to upload file on s3 bucket.
      const type = payload.fileName.split('.').pop();
      const timeStamp = Date.now();
      const fileName = `${payload.fileName}_${payload.companyId}_${timeStamp}.${type}`;
      console.log(process.env.VUE_APP_AGILLINK_BUCKET_NAME);
      const BUCKET_NAME = process.env.VUE_APP_AGILLINK_BUCKET_NAME;
      const IAM_USER_KEY = process.env.VUE_APP_AWS_IAM_USER_KEY;
      const IAM_USER_SECRET = process.env.VUE_APP_AWS_IAM_USER_SECRET;
      const s3bucket = new AWS.S3({
        accessKeyId: IAM_USER_KEY,
        secretAccessKey: IAM_USER_SECRET,
        Bucket: BUCKET_NAME,
      });
      const params = {
        Bucket: BUCKET_NAME,
        Key: fileName,
        Body: payload.uploadedFileData,
      };
      console.log(params);
      await s3bucket.upload(params, async (err) => {
        if (err) {
          console.log(err);
          console.log('err in uploading file');
        }
      });
      await apolloClient
        .mutate({
          mutation: SET_AL_STORE_AGILLINK_CATEGORIES_GQL,
          variables: {
            alChartofAccounts: payload.alChartofAccounts,
            type: payload.type,
          },
        })
        .then(({ data }) => {
          console.log('data', data.storeAgilLinkCategories);
          commit('SET_AL_STORED_AGILLINK_CATEGORIES', data.storeAgilLinkCategories);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getAgilLinkCreditCardAccountList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_AL_STORED_AGILLINK_CC_ACCOUNTS_GQL,
          variables: {
            companyId: payload.companyId,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          console.log(data);
          commit('GET_AL_STORED_AGILLINK_CC_ACCOUNTS', data.agillinkCcAccs);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getAllTabCcAccountValue({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_ALL_TAB_CC_ACC_VALUE_GQL,
          variables: {
            companyId: payload.companyId,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_ALL_TAB_CC_ACC_VALUE', data.agillinkCcAccSels);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getSelectedCreditCardAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_AL_SELECTED_CC_ACCOUNT_GQL,
          variables: {
            companyId: payload.companyId,
            activeTabName: payload.activeTabName,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          let agillinkCreditCard = {};
          console.log(data.agillinkCcAccSels);
          if (data.agillinkCcAccSels.length > 0) {
            agillinkCreditCard = data.agillinkCcAccSels[0];
          }
          commit('GET_AL_SELECTED_CC_ACCOUNT', agillinkCreditCard);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(() => {
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getStoredAgilLinkCategories({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_AL_STORED_AGILLINK_CATEGORIES_GQL,
          variables: {
            companyId: payload.companyId,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          console.log(data);
          commit('GET_AL_STORED_AGILLINK_CATEGORIES', data.agillinkCategories);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async createAgilLinkCreditCardAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: SET_AL_STORE_CREDITCARD_ACCOUNT_GQL,
          variables: {
            agillinkCcAccId: payload.agillinkCcAccId,
            companyId: payload.companyId,
            activeTabName: payload.activeTabName,
          },
        })
        .then(({ data }) => {
          let agillinkCreditCard = {};
          if (data.storeAgilLinkCreditCardAccount.text !== '') {
            agillinkCreditCard = JSON.parse(data.storeAgilLinkCreditCardAccount.text);
          }
          commit('SET_AL_STORE_CREDITCARD_ACCOUNT', agillinkCreditCard);
        });
    },
    async storeSyncTransactionToggleValue({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: SET_AL_STORE_SYNC_TRANSACTION_TOGGLE_VALUE_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SET_AL_STORE_SYNC_TRANSACTION_TOGGLE_VALUE', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async storeAgillinkAccountingCategories({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      const { unmappedCategories } = payload;
      await apolloClient
        .mutate({
          mutation: SET_AL_STORE_MAPPED_CATEGORIES_GQL,
          variables: {
            companyId: payload.companyId,
            mappedAlAccCategoriesList: payload.mappedCategories,
            ccAccountId: payload.ccAccountId,
          },
        })
        .then(() => {
          apolloClient
            .mutate({
              mutation: SET_AL_STORE_UNMAPPED_CATEGORIES_GQL,
              variables: {
                companyId: payload.companyId,
                unmappedAlAccCategoriesList: unmappedCategories,
              },
            })
            .then((dataOne) => {
              console.log(dataOne);
              commit('SET_AL_STORED_AGILLINK_ACCOUNTING_CATEGORIES', dataOne.data.storeUnmappedAlCategories);
              commit('shared/SET_LOADING', false, { root: true });
            })
            .catch((dataOneerr) => {
              console.log(dataOneerr);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async syncAgilLinkTransaction({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_AL_POST_TRANSACTIONS_GQL,
          variables: payload,
        })
        .then((postTran) => {
          const syncTranRes = {
            status: postTran.data.postAgilLinkTransactions.status,
            message: postTran.data.postAgilLinkTransactions.message,
          };
          commit('SET_SYNC_AL_TRAN', syncTranRes);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async markTransactionDownloaded({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_AL_MARK_TRANSACTIONS_DOWNLOADED_GQL,
          variables: payload,
        })
        .then(() => {
          commit('SET_AL_TRAN_MARK_DONWLOADED', 1);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async disConnectAgilLinkSys({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient.mutate({
        mutation: SET_ALSYS_DISCONNECT_GQL,
        variables: {
          companyId: payload.companyId,
        },
      }).then((disConnectAgilLinkSysdata) => {
        commit('SET_ALSYS_DISCONNECT', disConnectAgilLinkSysdata.data.disConnectAgilLinkSys);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      }).catch(disConnectAgilLinkSyserr => {
        console.log(disConnectAgilLinkSyserr);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      });
    },
    async updateMappedAgilLinkCategories({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient.mutate({
        mutation: SET_UPDATE_MAPPED_CATEGORIES_GQL,
        variables: {
          mappedCategoriesList: payload.mappedCategories,
        },
      }).then((updateMappedAgilLinkCategoriesdata) => {
        commit('SET_UPDATE_MAPPED_CATEGORIES', updateMappedAgilLinkCategoriesdata.data);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      }).catch(updateMappedAgilLinkCategorieserr => {
        console.log(updateMappedAgilLinkCategorieserr);
        commit('shared/SET_LOADING', false, {
          root: true,
        });
      });
    },
  },

  getters: {
    agilLinkCategoriesStored: state => state.agilLinkCategoriesStored,
    storedAgillinkCategories: state => state.storedAgillinkCategories,
    agilLinkAccountingCategoriesStored: state => state.agilLinkAccountingCategoriesStored,
    syncedAgilLinkTransactions: state => state.syncedAgilLinkTransactions,
    markDownloaded: state => state.markDownloaded,
    agilLinkSysDisConnected: state => state.agilLinkSysDisConnected,
    agilLinkCcAccountList: state => state.agilLinkCcAccountList,
    selectedCreditCardAccount: state => state.selectedCreditCardAccount,
    // ledgerEntries: state => state.ledgerEntries
    updatedMappedCategories: state => state.updatedMappedCategories,
    allTabCcAccValueList: state => state.allTabCcAccValueList,
    syncTransactionToggleValue: state => state.syncTransactionToggleValue,
  },
};
